import { useState } from "react";
import {
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";

import { useTenant } from "../../context/TenantContext";
import useRoleAllocationBoard, {
  ROLE_ALLOCATION_VIEW_MODES,
} from "../../hooks/useRoleAllocationBoard";

import RoleBoard from "./roleBoard";

const RoleAllocation = () => {
  const { tenantId } = useTenant();

  const [viewMode, setViewMode] =
    useState(
      ROLE_ALLOCATION_VIEW_MODES.PEOPLE
    );

  const [
    departmentId,
    setDepartmentId,
  ] = useState(null);

  const {
    roleColumns,
    tenantUsers,
    departments,
    sops,
    loading,
    error,
    refetch,
    ...mutations
  } = useRoleAllocationBoard({
    tenantId,
    departmentId,
    viewMode,
  });

  if (!tenantId) {
    return (
      <Box p={3}>
        <Typography
          sx={{
            color:
              "var(--tenant-primary)",
          }}
        >
          Select a tenant to view role
          allocation.
        </Typography>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box p={3}>
        <CircularProgress
          sx={{
            color:
              "var(--tenant-primary)",
          }}
        />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Typography color="error">
          Failed to load role allocation
          board
        </Typography>
      </Box>
    );
  }

  return (
    <RoleBoard
      roles={roleColumns}
      departments={departments}
      tenantUsers={tenantUsers}
      sops={sops}
      viewMode={viewMode}
      setViewMode={setViewMode}
      departmentId={departmentId}
      setDepartmentId={
        setDepartmentId
      }
      refetch={refetch}
      {...mutations}
    />
  );
};

export default RoleAllocation;